import React from 'react';
import {
  ShoppingBag,
  Sparkles,
  Layers,
  Info,
  Search,
  Moon,
  Sun,
  Menu,
  X,
  ChevronDown,
  ChevronRight,
  Check,
  CheckCircle2,
  Star,
  Minus,
  Plus,
  Truck,
  RotateCw,
  RefreshCw,
  ShieldCheck,
  ThumbsUp,
  Heart,
  CircleUser,
  LogOut,
  XCircle,
  Home,
  Lock,
  ArrowLeft,
  AlertCircle,
  Loader2,
  Clock,
  MapPin,
  Package,
  CreditCard,
  AlertTriangle,
  ExternalLink,
  Calendar,
  Eye,
  UserPlus,
  User,
  Truck as TruckIcon2,
  Phone,
  Building,
  Hash,
  ArrowRight,
  ShoppingCart,
  Ruler,
  Shield,
  HelpCircle,
  Mail,
  KeyRound,
} from 'lucide-react';

const icons = {
  ShoppingBagIcon: ShoppingBag,
  SparklesIcon: Sparkles,
  RectangleStackIcon: Layers,
  InformationCircleIcon: Info,
  MagnifyingGlassIcon: Search,
  MoonIcon: Moon,
  SunIcon: Sun,
  Bars3Icon: Menu,
  XMarkIcon: X,
  ChevronDownIcon: ChevronDown,
  ChevronRightIcon: ChevronRight,
  CheckIcon: Check,
  CheckCircleIcon: CheckCircle2,
  StarIcon: Star,
  MinusIcon: Minus,
  PlusIcon: Plus,
  TruckIcon: Truck,
  ArrowPathIcon: RotateCw,
  ShieldCheckIcon: ShieldCheck,
  HandThumbUpIcon: ThumbsUp,
  HeartIcon: Heart,
  UserCircleIcon: CircleUser,
  ArrowRightOnRectangleIcon: LogOut,
  XCircleIcon: XCircle,
  HomeIcon: Home,
  LockClosedIcon: Lock,
  ArrowLeft: ArrowLeft,
  AlertCircle: AlertCircle,
  Loader2: Loader2,
  CheckCircle2: CheckCircle2,
  Clock: Clock,
  MapPin: MapPin,
  ShoppingBag: ShoppingBag,
  RefreshCw: RefreshCw,
  Check: Check,
  PackageIcon: Package,
  CreditCardIcon: CreditCard,
  AlertTriangleIcon: AlertTriangle,
  ClockIcon: Clock,
  ExternalLinkIcon: ExternalLink,
  Loader2Icon: Loader2,
  RefreshCwIcon: RefreshCw,
  MapPinIcon: MapPin,
  CalendarIcon: Calendar,
  EyeIcon: Eye,
  UserPlusIcon: UserPlus,
  UserIcon: User,
  Info: Info,
  Truck: TruckIcon2,
  User: User,
  Phone: Phone,
  Building: Building,
  Hash: Hash,
  ArrowRight: ArrowRight,
  ShoppingCart: ShoppingCart,
  Ruler: Ruler,
  Shield: Shield,
  HelpCircle: HelpCircle,
  Mail: Mail,
  KeyIcon: KeyRound,
  CheckCircle2Icon: CheckCircle2,
} as const;

export type IconName = keyof typeof icons;

type IconProps = {
  name: IconName;
  size?: number;
  className?: string;
};

export default function Icon({ name, size = 24, className = '' }: IconProps) {
  const LucideIcon = icons[name] ?? icons.ShoppingBagIcon;
  return <LucideIcon size={size} className={className} />;
}
